<template>
  <iStyledCard show-border>
    <template #title-section>
      <iColumn gap="small" align="center">
        <iText :font-size="'extraLarge'" :font-weight="'dark'">
          {{ subscriptionPlan.name }}
        </iText>
        <iText :font-size="'large'">
          {{ formattedPrice }} / {{ formattedBillingFrequency }}
        </iText>
      </iColumn>
    </template>
    <template #description>
      <iText :font-weight="'dark'" text-align="center">
        {{ subscriptionPlan.description }}
      </iText>
      <iColumn
        v-for="product in activeProducts"
        :key="product.subscription_product_id"
        gap="extraSmall"
      >
        <iRow gap="small" vertical-align="middle" wrap="nowrap">
          <iIcon
            :icon="product.status === 'active' ? 'check-circle' : 'close'"
            size="small"
            :variant="product.status === 'active' ? 'primary' : 'secondary'"
          />
          <iText :variant="product.status === 'active' ? 'standard' : 'subtle'">
            {{ product.display_text }}
          </iText>
        </iRow>
      </iColumn>
    </template>
  </iStyledCard>
</template>

<script>
import { formatCurrency } from "@bloglovin/vue-framework";

export default {
  name: "NetworkSubscriptionPlanCard",
  props: {
    subscriptionPlan: {
      type: Object,
      required: true,
    },
  },
  computed: {
    activeProducts() {
      return (this.subscriptionPlan.subscription_products || []).filter(
        product => product.status === "active" || product.status === "not_included",
      );
    },
    formattedPrice() {
      return formatCurrency(
        parseFloat(this.subscriptionPlan.price || 0),
        this.subscriptionPlan.currency_code || "USD",
        "en-US",
        { minimumFractionDigits: 2, maximumFractionDigits: 2 },
      );
    },
    formattedBillingFrequency() {
      const freq = this.subscriptionPlan.billing_frequency || "";
      return freq.charAt(0).toUpperCase() + freq.slice(1);
    },
  },
};
</script>

<style scoped></style>
